import { MOBILE_LAYOUT_LENGTH } from "constants/UIConstants";
import styled from "styled-components";

export const Wrapper = styled.div`
  width: 100%;
  margin-bottom: 20rem;
  z-index: 1;
  height: 26rem;

  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    height: 31rem;
    margin-bottom: 5rem;
  }
`;

export const Background = styled.div`
  background-color: #a3e2fd;
  width: 192rem;
  position: absolute;
  height: 26rem;
  left: -36rem;
  z-index: -1;

  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    width: 100vw;
    height: 31rem;
    left: 0;
  }
`;

export const Container = {
  Wrapper: styled.div`
    width: 100%;
    display: flex;
    gap: 15rem;

    @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
      flex-direction: column;
      gap: 2rem;
    }
  `,
  TextWrapper: styled.div`
    display: flex;
    flex-direction: column;
    gap: 1.3rem;

    @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
      gap: 1rem;
    }
  `,

  Title: styled.div`
    margin-top: 8rem;
    font-size: 4rem;
    font-weight: bold;

    @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
      font-size: 2.4rem;
      margin-top: 2.4rem;
    }
  `,
  Text: styled.div`
    font-size: 1.8rem;
    @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
      font-size: 1.6rem;
      display: flex;
      flex-direction: column;
      line-height: 2.4rem;
    }
  `,
};

export const QR = {
  Wrapper: styled.div`
    display: flex;
    gap: 2rem;
    margin-top: 3rem;
    @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
      margin-top: 0rem;
    }
  `,
  Container: styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
  `,
  Img: styled.img`
    width: 18rem;
    height: 18rem;
    cursor: pointer;
    @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
      width: 12rem;
      height: 12rem;
    }
  `,
  Text: styled.div`
    font-size: 2rem;
    cursor: pointer;
    @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
      font-size: 1.8rem;
    }
  `,
};
